export const LOCAL_LANGUAGE = 'inspire-inquiry-language';
